import Cookies from 'js-cookie';

const isUserLoggedIn = () => !!Cookies.get('edxloggedin');

export default isUserLoggedIn;
